import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  blockUsers,
  changeUserPassword,
  deleteUsers,
  deleteUserSessions,
  downloadUserAllLogs,
  getChatReportUserList,
  getUserAllFilters,
  getUserDetail,
  getUserFilters,
  getUserFolders,
  getUserLabels,
  getUsers,
  getUserSessions,
  getUserTodayLogs,
  inactiveUserSessions,
  restoreUsers,
  unblockUsers,
} from "store/services/users";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All user
export const GetAllUsersAction = createAsyncThunk(
  "user/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUsers(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete user
export const DeleteUsersAction = createAsyncThunk(
  "user/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteUsers(rest);

      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(closeAdminModal());
        const responce = await getUsers(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update user
export const BlockUsersAction = createAsyncThunk(
  "user/block",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await blockUsers(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        const responce = await getUsers(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//change user password
export const ChangeUsersPasswordAction = createAsyncThunk(
  "user/changeUserPass",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await changeUserPassword(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update user
export const UnblockUsersAction = createAsyncThunk(
  "user/unblock",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await unblockUsers(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        const responce = await getUsers(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update user
export const RestoreUsersAction = createAsyncThunk(
  "user/restore",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await restoreUsers(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        const responce = await getUsers(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Get All user
export const GetUserDetailAction = createAsyncThunk(
  "user/getUserDetail",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserDetail(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Get user folder
export const GetUserFoldersAction = createAsyncThunk(
  "user/getUserFolders",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserFolders(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Get user labels
export const GetUserLabelsAction = createAsyncThunk(
  "user/getUserLabels",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserLabels(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Get user filter
export const GetUserFiltersAction = createAsyncThunk(
  "user/getUserFilters",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserFilters(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Get all filters
export const GetUserAllFiltersAction = createAsyncThunk(
  "user/getUserAllFilters",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserAllFilters(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Get all Sessions
export const GetUserSessionsAction = createAsyncThunk(
  "user/getUserSessions",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserSessions(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Get all logs
export const GetUserTodayLogsAction = createAsyncThunk(
  "user/getUserTodayLogs",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getUserTodayLogs(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Get all logs
export const DownloadUserAllLogsAction = createAsyncThunk(
  "user/downloadUserAllLogs",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await downloadUserAllLogs(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const DeleteUserSessionsAction = createAsyncThunk(
  "userSessions/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;          // filter = current filterObj + user id
      const res = await deleteUserSessions(rest);

      if (res.status === 1) {
        const responce = await getUserSessions(filter);   // re-fetch with same filters
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const InactiveUserSessionsAction = createAsyncThunk(
  "userSessions/inactive",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await inactiveUserSessions(rest);

      if (res.status === 1) {
        const responce = await getUserSessions(filter);   // re-fetch with same filters
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Get Chat Report User list
export const GetChatReportUserAction = createAsyncThunk(
  "user/getChatReportUserList",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getChatReportUserList(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
